import React, { Component } from 'react';
import $ from 'jquery';

import { Link } from 'react-router';
import { Col } from 'react-bootstrap';

import Icon from '../Icon';

import GenericBlock from './GenericBlock';

import './Block.css'

class MainBlock extends Component {

    clickLink(e) {
        // Check if we need to handle this click
        if ( ! this.props.linkTarget.startsWith("#"))
            return true;

        e.preventDefault();

        var scrollTop = ($(this.props.linkTarget).offset().top - $(".navbar-default").height());
        $('html, body').animate({
            scrollTop: scrollTop
        }, 200);
    }

    renderTitle() {
        if (this.props.linkTarget) {
            return (
                <div className="title">
                    <Link to={this.props.linkTarget} className="title-url" onClick={this.clickLink.bind(this)}>
                        <Icon icon={this.props.icon} size={36} />
                        <h4>{this.props.title}</h4>
                    </Link>
                </div>
            );
        }

        return (
            <div className="title">
                <Icon icon={this.props.icon} size={36} />
                <h4>{this.props.title}</h4>
            </div>
        );
    }

    render() {
        return(
            <GenericBlock className={"block-main "+ this.props.className}>
                <Col md={12}>
                    <div className="contents">
                        {this.renderTitle()}

                        <div className="text">{this.props.text}</div>
                        <div className="spacer" />
                        <div className="video">{this.props.video}</div>
                    </div>
                </Col>
            </GenericBlock>
        );
    }

}

export default MainBlock;



// WEBPACK FOOTER //
// ./src/components/blocks/MainBlock.js